import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/arrow-right-up.svg'


const _withScopeId = n => (_pushScopeId("data-v-f4443108"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  "aria-hidden": "true"
}, null, -1))

import { computed } from 'vue';
import * as telemetry from '@/lib/telemetry';
import { useClaimStore } from '@/store/claimStore';

const STUDIO_LINK_CAMPAIGN_AND_MEDIUM = 'utm_medium=post-checkout&utm_campaign=app-link';

type CreateYourOwnProps = {
  instanceSlug?: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateYourOwn',
  props: {
    instanceSlug: { default: '' }
  },
  setup(__props: any) {

const props = __props;



const store = useClaimStore();

const trackClick = () => {
  store.analytics.capture({
    event: telemetry.TELEMETRY_MAPPING.mintFlow.CREATE_YOUR_OWN_BUTTON_CLICK,
  });
};

const studioLink = computed(() => {
  const utmContent = props.instanceSlug ? `&utm_content=${props.instanceSlug}` : '';
  const appPath = store.appId ? `apps/${store.appId}/new` : '';
  return `https://studio.manifold.xyz/${appPath}?utm_source=c&${STUDIO_LINK_CAMPAIGN_AND_MEDIUM}${utmContent}`;
});

return (_ctx: any,_cache: any) => {
  return (studioLink.value)
    ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        target: "_blank",
        href: studioLink.value,
        onClick: trackClick,
        class: "m-claim__create-your-own"
      }, [
        _createTextVNode(" CREATE YOUR OWN "),
        _hoisted_2
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})